import { AlignBar as alignBar } from "./AlignBar";
import { ColorPicker as color } from "./ColorPicker";
import { Group as group } from "./Group";
import { Inputs as inputs } from "./Inputs";
import { InputsGroup as inputsGroup } from "./InputsGroup";
import { Label as label } from "./Label";
import { Select as select } from "./Select";
import { Stroke as stroke } from "./Stroke";
import { StrokeGroup as strokeGroup } from "./StrokeGroup";
import { Text as text } from "./Text";
import { Textarea as textarea } from "./Textarea";
import { TextProps as textProps } from "./TextProps";
import { Uploader as image } from "./Uploader";
import { Empty as empty } from "./EmptyState";
import { HeaderPosition as headerPosition } from "./HeaderPosition";
import { Enable as enable } from "./Enable";

export const items = {
	text,
	textarea,
	group,
	inputs,
	color,
	image,
	inputsGroup,
	stroke,
	strokeGroup,
	textProps,
	alignBar,
	label,
	select,
	empty,
	headerPosition,
	enable,
};
